export const cacheStorage = {
    savePhotoToLocalStorage,
    getPhotoFromLocalStorage,
    removeFromLocalStorage
};

function savePhotoToLocalStorage(filename, signedUrl){
    localStorage.setItem(filename, signedUrl);
}

function getPhotoFromLocalStorage(filename) {
    return localStorage.getItem(filename);
}

function removeFromLocalStorage(filename) {
    localStorage.removeItem(filename);
}